import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  prevPage: {
    id: 'gradebook.GradesView.PageButtons.prevPage',
    defaultMessage: 'Previous Page',
    description: 'Grades tab Previous Page button text',
  },
  nextPage: {
    id: 'gradebook.GradesView.PageButtons.nextPage',
    defaultMessage: 'Next Page',
    description: 'Grades tab Next Page button text',
  },
});

export default messages;
